var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89453 9.89477C9.89453 4.40728 14.3018 0 19.7893 0C25.2336 0 29.6841 4.40728 29.6841 9.89477H9.89453Z",
    fill: "#08576D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.7895C0 14.3453 4.40728 9.89478 9.89477 9.89478C9.89477 15.3391 14.3021 19.7895 19.7895 19.7895C14.3453 19.7895 9.89477 24.1968 9.89477 29.6843C4.40728 29.6411 0 25.2338 0 19.7895Z",
    fill: "#08576D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6411 29.6411C29.6411 35.0854 25.2338 39.5359 19.7463 39.5359C14.3021 39.5359 9.85156 35.1286 9.85156 29.6411H29.6411Z",
    fill: "#08576D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6409 9.89478C35.0852 9.89478 39.5356 14.3021 39.5356 19.7895C39.5356 25.2338 35.1284 29.6843 29.6409 29.6843C29.6409 24.24 25.2336 19.7895 19.7461 19.7895C25.2336 19.7895 29.6409 15.3391 29.6409 9.89478Z",
    fill: "#08576D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3864 29.6411H65.8495V16.3761L60.0595 29.6411L53.9239 16.3329V29.6411H49.6895V9.89478H55.7387L60.1027 20.1352L64.2508 9.89478H70.3864",
    fill: "#08576D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9609 9.89478H84.0409V13.3515H77.0843V17.8884H83.7816V21.2586H77.0843V26.3141H84.0409V29.6411H72.6338V9.89478",
    fill: "#08576D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.837 10.8886C111.003 7.43186 101.065 11.2342 101.065 19.7895C101.065 27.135 108.757 33.0546 116.837 29.0794V24.8449C110.615 29.209 105.17 24.8449 105.257 19.9192C105.3 16.6785 107.504 13.5675 111.738 13.3514C113.812 13.2218 115.238 13.7403 116.837 15.2958V10.8886Z",
    fill: "#08576D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.886 10.0676H118.694V29.6411H122.886V10.0676Z",
    fill: "#08576D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.663 29.6411L123.317 19.055L129.626 10.1108H134.552L128.2 19.055L135.459 29.6411",
    fill: "#08576D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0283 9.89478H93.8059C98.386 9.89478 100.287 13.5675 100.287 15.8144C100.287 18.0612 99.423 20.3081 96.7441 21.3451L102.534 29.6411H97.8243L90.4788 19.0118V29.6411H86.0283V9.89478ZM92.8553 18.9254C94.5404 18.9254 95.8367 17.6291 95.8367 16.1168C95.8367 15.3391 95.6638 13.1786 92.38 13.1786H90.4356V18.9686H92.8553V18.9254Z",
    fill: "#08576D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerck);
export default __webpack_public_path__ + "static/media/merck.0ed5e461766e7d8ec8144760d184beb5.svg";
export { ForwardRef as ReactComponent };